// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".2223eac2a0aebf7054f85eaf324033d9ad34aa19.chunk.bundle.js";
};